import { useTranslation } from 'react-i18next';
import { ReactComponent as Looking } from '../../assets/looking.svg';
import AddChatroomButton from './AddChatroomButton';
import ViewCreatorsButton from './ViewCreatorsButton';

export default function NoChatroom({ isABO }: { isABO: boolean }) {
  const [t] = useTranslation(['chatroom']);
  if (isABO) {
    return (
      <div className="flex flex-col items-center pb-4 py-6 pt-6 w-full">
        <Looking className="mb-5 px-4" />
        <div className="px-4 mb-5">
          <div className="text-center mb-4">
            <span className="font-medium text-2xl">
              {t('no_chatroom_isABO_title', '讓社群助手幫你一把')}
            </span>
          </div>
          <span>
            {t(
              'no_chatroom_isABO_description',
              '由安麗機器人每天出任務給所有組員，你也能隨時掌控組員進度，並給予回饋'
            )}
          </span>
        </div>
        <div className="w-full flex flex-row justify-evenly gap-4 px-4">
          <div className="w-1/2 self-center">
            <AddChatroomButton />
          </div>
          <div className="w-1/2 self-center">
            <ViewCreatorsButton />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center pb-4 py-6 pt-6 w-full">
      <Looking className="mb-5 px-4" />
      <div className="px-4">
        <div className="text-center mb-4">
          <span className="font-medium text-2xl">
            {t('no_chatroom_status', '目前沒有加入的活動工作群')}
          </span>
        </div>
      </div>
    </div>
  );
}
